import React from 'react';

interface SymbolProps {
  size?: number;
  style?: React.CSSProperties;
}

export const StairsSymbol: React.FC<SymbolProps> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="-5 -5 106 106"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
  >
    <polyline
      points="0,96 24,96 24,72 48,72 48,48 72,48 72,24 96,24 96,0"
      fill="none"
      stroke="black"
      strokeWidth="10"
      strokeLinecap="square"
      strokeLinejoin="miter"
    />
  </svg>
);

export const EngineSymbol: React.FC<SymbolProps> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block' }}
  >
    {/* engine-motor-icon shape — recreated as inline SVG path */}
    <path
      fill="black"
      d="M176 48h-48a16 16 0 0 0-16 16v32H80a16 16 0 0 0-16 16v32H48a16 16 0 0 0-16 16v192a16 16 0 0 0 16 16h16v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h224v32a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16v-32h16a16 16 0 0 0 16-16V160a16 16 0 0 0-16-16h-16v-32a16 16 0 0 0-16-16h-32V64a16 16 0 0 0-16-16h-48a16 16 0 0 0-16 16v32H192V64a16 16 0 0 0-16-16zM256 336l-64-80h40v-80l64 80h-40v80z"
    />
  </svg>
);

export const MusterSymbol: React.FC<SymbolProps> = ({ size = 24, style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: 'block', ...style }}
  >
    <rect width="100" height="100" fill="#1e7d1e" />
    <path
      transform="translate(22,78) rotate(-45)"
      d="M-14,-4 H2 V-10 L14,0 L2,10 V4 H-14 Z"
      fill="white"
    />
    <path
      transform="translate(22,22) rotate(45)"
      d="M-14,-4 H2 V-10 L14,0 L2,10 V4 H-14 Z"
      fill="white"
    />
    <path
      transform="translate(78,78) rotate(-135)"
      d="M-14,-4 H2 V-10 L14,0 L2,10 V4 H-14 Z"
      fill="white"
    />
    <path
      transform="translate(78,22) rotate(135)"
      d="M-14,-4 H2 V-10 L14,0 L2,10 V4 H-14 Z"
      fill="white"
    />
  </svg>
);

export const AREA_SYMBOLS: Record<string, React.FC<SymbolProps>> = {
  stairs: StairsSymbol,
  engine: EngineSymbol,
  muster: MusterSymbol,
};

export const AREA_SYMBOL_LABELS: Record<string, string> = {
  stairs: 'Stairs',
  engine: 'Engine Room',
  muster: 'Muster Station',
};
